module.exports = __webpack_public_path__ + "img/29.cf5d895f.png";